<!-- eslint-disable max-len -->
<template>
	<section
		class="subnav-container"
		:class="{ 'expanded': expanded, 'conmkt': isContMktTab }"
		v-if="data"
	>
		<div
			class="subnav-wrapper"
			:class="{
				'expanded': expanded,
				'sticky': sticky,
				'show': show,
				'non-guide-sticky': mode !== 'guide' && sticky
			}"
		>
			<div class="subnav-toggle-container">
				<a
					:href="`${domain}${tocLink.url}`"
					class="guide-nav"
					v-if="!sfLogo"
					v-metric="{ module: metricsModule, link: 'toc' }"
				>
					<img
						class="icon"
						src="https://img.lb.staging.wbmdstatic.com/vim/staging/webmd/consumer_assets/site_images/library_books.svg"
					/>
					<span
						class="main-title"
						v-if="mode === 'guide'"
					>
						{{ subnavtitle }}
					</span>
					<span
						class="main-title"
						v-else
					>
						{{ data.title }}
					</span>
				</a>

				<a
					:href="`${domain}${tocLink.url}`"
					class="logo"
					v-if="sfLogo"
					v-metric="{ module: metricsModule, link: 'logo' }"
				>
					<img
						class="sf-logo"
						:src="sfLogo"
						alt=""
					/>
				</a>

				<button
					@click="toggleNav()"
					class="subnav-toggle"
					:class="{ 'expanded': expanded , 'sf-btn': sfLogo}"
					v-if="(!sticky && !isMobile) || isMobile"
				>
					<span
						class="guide-text"
						v-if="mode === 'guide'"
					>
						{{ sfLogo ? data.title : 'Guide' }}
					</span>
					<span
						class="non-guide-text"
						v-if="mode !== 'guide'"
					>
						More
					</span>
					<span class="subnav-caret">
						<i class="webmd-icon-down-arrow"></i>
					</span>
				</button>
			</div>
			<div
				class="subnav-content"
				:class="{ 'expanded': expanded, 'sticky': sticky }"
			>
				<ul
					class="subnav-content"
					v-metric="{ module: metricsModule }"
					:class="{ 'with-more': visibilityState.filter(v => !v).length > 0 }"
				>
					<li
						v-for="(chapter, $index) in data.chapters"
						:key="$index"
						class="subnav-chapter"
						v-show="visibilityState[$index]"
						:class="{ 'expanded': openState[$index], 'active': isActive(chapter, $index) }"
					>
						<span
							v-if="chapter.sections.length > 1"
							class="subnav-chapter-title"
							@click="toggleSection($index)"
						>
							{{ chapter.title }}
							<i class="webmd-icon-down-arrow"></i>
						</span>
						<a
							v-else
							class="subnav-chapter-title"
							:href="chapter.sections[0].link"
							v-metric="{ link: $index + 1 }"
						>
							{{ chapter.title }}
						</a>
						<ul
							v-if="chapter.sections.length > 1"
							class="subnav-chapter-links"
						>
							<li
								v-for="(section, $indexA) in chapter.sections"
								:key="$indexA"
							>
								<a
									:href="section.link"
									v-metric="{ link: `${$index + 1}_${$indexA + 1}` }"
								>
									{{ section.title || `Section ${$indexA + 1}` }}
								</a>
							</li>
						</ul>
					</li>
					<li
						class="subnav-chapter toc-link"
						v-if="mode === 'guide'"
					>
						<a
							class="subnav-chapter-title"
							:href="`${domain}${tocLink.url}`"
						>
							View Full Guide
						</a>
					</li>
				</ul>
				<span
					class="subnav-chapter subnav-more"
					v-if="visibilityState.filter(v => !v).length > 0"
				>
					<span
						class="subnav-chapter-title"
						@click="toggleSection('more')"
					>
						More
						<i class="webmd-icon-down-arrow"></i>
					</span>
					<ul
						class="subnav-chapter-links"
						v-metric="{ module: metricsModule }"
					>
						<li
							v-for="(chapter, $index) in data.chapters"
							:key="$index"
							class="subnav-more-chapter"
							v-show="!visibilityState[$index]"
							:class="{ 'expanded': moreOpenState[$index], 'active': isActive(chapter, $index) }"
						>
							<span
								v-if="chapter.sections.length > 1"
								class="subnav-more-chapter-title"
								@click="toggleSection($index, true)"
							>
								{{ chapter.title }}
								<i class="webmd-icon-down-arrow"></i>
							</span>
							<a
								v-else
								class="subnav-more-chapter-title"
								:href="chapter.sections[0].link"
								v-metric="{ link: $index + 1 }"
							>
								{{ chapter.title }}
							</a>
							<ul
								v-if="chapter.sections.length > 1"
								class="subnav-more-chapter-links"
							>
								<li
									v-for="(section, $indexA) in chapter.sections"
									:key="$indexA"
								>
									<a
										:href="section.link"
										v-metric="{ link: `${$index + 1}_${$indexA + 1}` }"
									>
										{{ section.title || `Section ${$indexA + 1}` }}
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</span>
			</div>
		</div>
		<SetRendered />
	</section>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

import _has from 'lodash/has';
import _concat from 'lodash/concat';
import _filter from 'lodash/filter';
import throttle from 'lodash/throttle';
import SetRendered from './components/SetRendered.vue';

export default {
	data() {
		return {
			data: false,
			expanded: false,
			openState: {},
			moreOpenState: {},
			visibilityState: [],
			sticky: false,
			show: false,
			isMobile: true,
			isSmallTablet: false,
			isTabletBig: false,
			metricsModule: 'hdr-sub',
			tocLink: {},
			domain: 'https://www.webmd.com',
			isActiveOnLoad: false,
			mode: 'guide',
			ecdQuery: '',
			isContMktTab: false,
			subnavtitle: '',
		};
	},

	components: { SetRendered },

	created() {
		this.store = useStore(this.$pinia);
		this.pubSrc = (this.store?.pagedata?.omniture?.s_publication_source || '').toLowerCase();
		this.data = this.getModuleData;
		this.tocLink = this.getTocLink;
		this.ecdQuery = this.$route?.query?.ecd || '';
		this.subnavtitle = this.getTitle;
	},

	computed: {
		getTitle() {
			const module = this.store.cms.friendlyURLData;
			let name;

			if (_has(module, 'target.centers.Health.friendlyurl')) {
				name = module.target.centers.Health['#text'];
				return name;
			}
			return {};
		},

		getModuleData() {
			const module = this.store.cms.getModules('shared_object');
			const currChannel = this.store.pagedata.omniture.center_id;
			const modules = _filter(this.store.cms.allModules, (m) => _has(m, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val') && m.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val === 'list');
			let title;

			if (_has(module, 'Guide_Article_Data.content_section.cons_guide_outline')) {
				if (currChannel !== module.Guide_Article_Data.metadata_section.wbmd_c_channel_id && module.Guide_Article_Data.metadata_section.wbmd_prim_subj_cd !== 'program') {
					return false;
				}

				return {
					title: module.Guide_Article_Data.metadata_section.title,
					// eslint-disable-next-line max-len
					chapters: this.formatChapter(module.Guide_Article_Data.content_section.cons_guide_outline.chapter_groups.chapter_group),
				};
			}

			if (modules && modules.length > 1) {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.mode = 'list';

				if (this.store.cms.friendlyURLData.target.breadcrumb.bread.length === undefined) {
					title = this.store.cms.friendlyURLData.target.breadcrumb.bread.piece;
				} else {
					title = this.store.cms.friendlyURLData.target.breadcrumb.bread[0].piece;
				}

				return {
					title,
					chapters: this.formatModules(modules),
				};
			}

			return false;
		},

		getTocLink() {
			const module = this.store.cms.friendlyURLData;

			if (_has(module, 'target.centers.Health.friendlyurl')) {
				return {
					name: module.target.centers.Health['#text'],
					url: module.target.centers.Health.friendlyurl,
				};
			}

			if (this.mode === 'list') {
				if (this.store.cms.friendlyURLData.target.breadcrumb.bread.length === undefined) {
					return { url: this.store.cms.friendlyURLData.target.breadcrumb.bread.friendlyurl };
				}

				return { url: this.store.cms.friendlyURLData.target.breadcrumb.bread[0].friendlyurl };
			}

			return {};
		},

		sfLogo() {
			const sfData = this.store.cms.siteFronts;
			const imgServer = this.store.pagedata.omniture.image_server_url;

			if (sfData && sfData.styleConfig && sfData.styleConfig.images
				&& sfData.styleConfig.images[0].path) {
				return `${imgServer}${sfData.styleConfig.images[0].path}`;
			}

			return null;
		},
	},

	mounted() {
		if (!this.data) {
			return;
		}

		if (window.location.origin) {
			this.domain = window.location.origin;
		}
		this.isMobile = window.screen.width < 1025;
		this.isSmallTablet = window.screen.width >= 768 && window.screen.width < 1025;
		this.isTabletBig = window.screen.width > 767;
		this.handleThrottleScroll = throttle(this.onScroll, 100);
		window.addEventListener('scroll', this.handleThrottleScroll, { passive: true });
		this.visibilityState = this.data.chapters.map(() => true);
		this.isContMktTab = window.screen.width > 767 && window.screen.width < 1025 && this.ecdQuery.includes('conmkt');
	},

	methods: {
		doMetrics(link) {
			if (window.wmdPageLink) {
				window.wmdPageLink({ moduleName: `${this.metricsModule}_${link}` });
			}
		},

		toggleNav() {
			const self = this;

			if (this.sticky && !this.isMobile) {
				return;
			}

			this.expanded = !this.expanded;

			if (this.expanded) {
				this.doMetrics('guide');

				if (!this.isMobile) {
					this.$nextTick(() => {
						self.checkVisibility();
					});
				}
			}
		},

		toggleSection(idx, moreMenu) {
			if (!this.isMobile && !moreMenu) {
				return;
			}

			if (moreMenu) {
				if (this.moreOpenState[idx]) {
					this.moreOpenState = {};
				} else {
					this.moreOpenState = {};
					this.moreOpenState[idx] = true;
					this.doMetrics(`more_${idx + 1}`);
				}
			} else if (this.openState[idx]) {
				this.openState = {};
			} else {
				this.openState = {};
				this.openState[idx] = true;
				this.doMetrics(idx + 1);
			}

			this.$forceUpdate();
		},

		onScroll() {
			// To hide subnav on small tablet while 101 sticky ad is visible
			if (this.isSmallTablet && window.pageYOffset < 1100 && window.pageYOffset > 0) {
				this.sticky = false;
				return;
			}

			if (this.$route && this.$route.query && this.$route.query.ecd && this.$route.query.ecd.includes('conmkt')) {
				if (this.store.pagedata.omniture.s_business_reference.toLowerCase() === 'tool - slide show') {
					if (this.isTabletBig) {
						this.sticky = false;
						return;
					}
				}
			}

			// Because of momentum scrolling on mobiles, adding minimum offset value
			if ((window.pageYOffset < 400 && this.isMobile)
				|| (window.pageYOffset < 1100 && !this.isMobile)) {
				this.sticky = false;
				return;
			}

			this.sticky = true;

			this.checkVisibility();

			if (this.expanded) {
				this.expanded = false;
			}

			if (window.pageYOffset > 1100 && !this.isMobile) {
				this.show = true;
			} else {
				this.show = window.pageYOffset > this.lastScrollPosition;
				this.lastScrollPosition = window.pageYOffset;
			}
		},

		formatChapter(data) {
			const chapterData = [];

			(data.length ? data : [data]).forEach((d) => {
				const outline = d.chapter_link.cons_guide_chapter_outline;
				const chapter = {
					title: outline.chapter_title,
				};
				let sections;

				if (outline.section_groups.section_group.length) {
					sections = outline.section_groups.section_group;
				} else {
					sections = [outline.section_groups.section_group];
				}

				chapter.sections = sections.map((s) => {
					const section = {
						title: s.section_full_title,
					};

					if (s.article_groups.article_group && s.article_groups.article_group.length) {
						section.link = s.article_groups.article_group[0]?.article_link?.link_friendlyUrl;
						chapter.paths = _concat(chapter.paths, s.article_groups.article_group.map((a) => a?.article_link?.link_friendlyUrl?.split('.com')[1]));
					} else if (s.article_groups.article_group) {
						section.link = s.article_groups.article_group?.article_link?.link_friendlyUrl;
						chapter.paths = _concat(chapter.paths, [s.article_groups.article_group?.article_link?.link_friendlyUrl?.split('.com')[1]]);
					}

					return section;
				});

				chapterData.push(chapter);
			});
			return chapterData;
		},

		formatModules(data) {
			return data.map((d) => ({
				title: d.module_data.module_title,
				paths: [],
				sections: d.module_data.links.link.map((l) => ({
					link: l.link_friendlyUrl,
					title: l.link_text,
				})),
			}));
		},

		checkVisibility() {
			const self = this;
			const store = self.data.chapters.map(() => true);
			const chapters = document.querySelectorAll('.subnav-chapter:not(.subnav-more)');

			self.visibilityState = store;

			self.$nextTick(() => {
				const container = document.querySelector('ul.subnav-content').clientWidth;

				chapters.forEach((c, i) => {
					store[i] = (c.offsetLeft + c.clientWidth) <= container;
				});

				self.visibilityState = store;
				self.$forceUpdate();
			});
		},

		isActive(chapter, idx) {
			const path = this.store.pagedata.omniture.s_furl;

			if (this.isActiveOnLoad) {
				return;
			}

			if (path) {
				if (chapter.paths.includes(path)) {
					if (chapter.sections.length > 1) {
						this.openState[idx] = true;
					}
					this.isActiveOnLoad = true;
					// eslint-disable-next-line consistent-return
					return true;
				}
			}

			// eslint-disable-next-line consistent-return
			return false;
		},
	},

	watch: {
		expanded(newVal) {
			if (newVal && this.sticky && this.isMobile) {
				document.body.setAttribute('data-content-masked', true);
			} else if (!newVal && this.sticky) {
				document.body.removeAttribute('data-content-masked');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
$sans: "Source Sans Pro", Arial, sans-serif;
$imperial: #00157C;
$rule: #C6CEDB;
$white: #FFF;
$bg: #F9F9FC;
$nebula: #EDF0FF;
$active-blue: #F2F7FF;
$ultramarine: #3557FF;
$wave: #D2D9FF;
$lavender: #CCCCE7;
$carbon: #1B1B1B;

$mobile: px2rem(600);
$tablet: px2rem(768);
$desktop: px2rem(1025);
$max-tablet: px2rem(1024);
$small-desktop: px2rem(1239);

html.sf-slideshow,
html.onc-slideshow {
	.subnav-container {
		left: 0;
		margin-left: 0;
		width: 100%;

		@media (min-width: $desktop) {
			width: calc(100% + #{px2rem(352)});
		}
	}
}

.subnav-container {
	color: $ultramarine;
	left: px2rem(-10);
	margin: 1rem 0;
	margin-left: px2rem(-10);
	min-height: px2rem(52);
	position: relative;
	width: calc(100% + #{px2rem(39)});

	@media screen and (min-width: 47.9375rem) and (max-width: 64rem) {
		left: 0;
		margin-left: 0;
		width: 100%;
	}

	@media (min-width: $desktop) {
		background-color: $nebula;
		border-radius: px2rem(4);
		left: px2rem(9);
		min-height: px2rem(54);
		width: calc(100% + #{px2rem(400)});

		&.expanded {
			border-radius: px2rem(4) px2rem(4) 0 0;
		}
	}

	@media (min-width: $desktop) and (max-width: $small-desktop) {
		left: -0.3875rem;
		width: calc(100% + 22rem);
	}

	.subnav-wrapper {
		box-shadow: 1px 6px 15px rgba(34, 62, 105, 0.08);
		font-size: 1rem;
		display: flex;
		background: $nebula;
		height: 52px;
		padding: 0 px2rem(10);

		@media (min-width: $desktop) {
			box-shadow: none;
			margin: 0 px2rem(20);
			height: 54px;
			padding: 0;
		}

		@media (max-width: $max-tablet) {
			display: flex;
		}

		.sf-logo {
			display: block;
			height: px2rem(32);
			margin-right: px2rem(4);
			min-width: px2rem(100);
			padding-right: px2rem(10);
		}

		.subnav-toggle-container {
			display: flex;
			width: -webkit-fill-available;
			align-items: center;

			@media (max-width: $max-tablet) {
				justify-content: space-between;
			}

			.guide-nav {
				display: flex;
				align-items: center;
				text-decoration: none;
				gap: px2rem(8);
				margin-right: px2rem(12);

				.icon {
					height: 1.875rem;
					width: 1.875rem;
				}

				.main-title {
					font-family: $sans;
					font-weight: 600;
					font-size: 16px;
					line-height: 1.6;
					color: $ultramarine;

					@media (min-width: $desktop) {
						border-bottom: 1px solid transparent;
						&:hover {
							border-bottom: 1px solid #3557FF;
						}
					}
				}
			}
		}

		&.sticky {
			transition: 0.3s all ease;
			top: -52px;
			left: 0;
			margin-top: 0;
			position: fixed;
			width: 100%;
			z-index: 100000;
			margin: 0;
			padding: 0 px2rem(20);

			@media (min-width: $desktop) {
				top: -52px;
			}

			.subnav-toggle-container {
				@media (min-width: $desktop) {
					width: auto;
					flex-grow: 1;
					justify-content: end;
					margin: .625rem 0;
					overflow: visible;
				}

				.sf-logo {
					@media (min-width: $desktop) {
						border-right: 1px solid #CCCCE7;
					}
				}
			}

			&.show {
				transform: translateY(px2rem(52));
				background: $nebula;
			}

			div.subnav-content {
				overflow-y: auto;
				max-height: calc(100vh - #{px2rem(48)});

				@media (min-width: $desktop) {
					background: $nebula;
					height: auto;
					max-width: calc(100% - 14rem);
					overflow: visible;
				}
			}

			@media (min-width: $desktop) {
				background: $nebula;
				display: flex;
				justify-content: center;

				button {
					border-radius: 0;
					border-right: 1px solid $lavender;
					cursor: default;
					flex-grow: 1;
					height: px2rem(32);
					justify-content: end;
					margin: px2rem(10) 0;
					overflow: visible;
					padding: 0 px2rem(12);

					&>span {
						border-radius: px2rem(4);
						font-size: px2rem(18);
						height: px2rem(34);
						line-height: 1.125;
						padding: 0 px2rem(10);
						text-align: left;
					}

					.subnav-caret {
						display: none;
					}

					.sf-logo {
						border-right: 0;
						margin-right: 0;
						padding-right: 0;
					}

					&:hover {
						&>span {
							background: $wave;
						}
					}
				}

				div.subnav-content {
					display: flex;
					flex-grow: 1;
					margin-top: 0;
					padding: 0 1rem 0 0;
				}

				.subnav-chapter-title {
					height: auto;
				}

				.subnav-chapter {
					padding: px2rem(8);

					&:hover {
						.subnav-chapter-title {
							background: $wave;
						}
					}
				}
			}
		}
	}

	.subnav-toggle {
		align-items: center;
		background: $ultramarine;
		border: 0;
		border-radius: px2rem(4);
		color: $white;
		cursor: pointer;
		display: flex;
		font-family: $sans;
		font-size: 1rem;
		font-weight: normal;
		height: 36px;
		width: 100px;
		padding: 0 px2rem(6) 0 px2rem(10);

		span {
			align-items: center;
			display: inline-flex;

			a {
				text-decoration: none;
				color: $ultramarine;
			}
		}

		.guide-text,
		.non-guide-text {
			font-size: 18px;
			color: $white;
			margin-right: 4px;
			font-family: $sans;
			font-weight: 600;
			line-height: 1.6;
		}

		.icon {
			height: px2rem(20);
			margin: 0 px2rem(6) 0 px2rem(6);
			vertical-align: middle;
			width: px2rem(20);
		}

		.subnav-caret {
			display: flex;
			padding: 0 px2rem(14);

			i {
				transition: 0.3s all ease;
			}
		}

		&.expanded {
			background: $imperial;

			i {
				color: $white;
				transform: rotate(180deg);
			}

			@media (min-width: $desktop) {
				color: $ultramarine;
			}

		}

		&.sf-btn {
			min-width: px2rem(100);
			width: unset;

			.guide-text {

				@media screen and (max-width: $mobile) {
					font-size: px2rem(14);
				}
			}
		}

		@media (min-width: $desktop) {
			display: inline-flex;
			font-size: px2rem(18);

			.icon {
				height: px2rem(20);
				margin-right: px2rem(9);
				margin-left: px2rem(4);
				width: px2rem(20);
			}

			span {
				align-items: center;
				display: flex;
			}

			.subnav-caret {
				height: 100%;

				i {
					color: $white;
					font-size: px2rem(14);
				}
			}

			&:hover {
				background: $imperial;
				border-radius: 0.25rem;
			}
		}
	}

	div.subnav-content {
		background: $bg;
		box-shadow: 1px 6px 15px rgba(34, 62, 105, 0.08);
		display: none;
		position: absolute;
		width: 100%;
		z-index: 1000;

		&.expanded {
			display: block;
			margin-top: 51px;
			margin-left: -9px;

			&.sticky {
				margin-left: -18px;
			}
		}

		@media (min-width: $desktop) {
			background: $white;
			border-radius: 0 0 px2rem(4) px2rem(4);
			box-shadow: none;
			display: flex;
			height: 0;
			margin-top: px2rem(2);
			padding: 0 px2rem(10);
			position: relative;
			width: auto;

			&:not(.sticky) {
				position: absolute;
				width: 100%;
			}

			&.expanded {
				display: flex;
				height: px2rem(52);
				margin-top: px2rem(54);
				margin-left: px2rem(-20);

				.subnav-chapter-title {
					height: 100%;
				}

				.subnav-chapter {
					padding: px2rem(10) 1rem px2rem(10) 0;
				}
			}
		}
	}

	ul.subnav-content {
		list-style: none;
		margin: 0;
		padding: 0;

		@media (min-width: $desktop) {
			display: flex;
			width: calc(100% - #{px2rem(80)});
		}
	}

	.subnav-more {
		display: none;

		@media (min-width: $desktop) {
			.subnav-chapter-links {
				right: 0;
			}

			.subnav-more-chapter-links {
				display: none;
			}

			.subnav-more-chapter-title {
				display: flex;
				justify-content: space-between;
				padding: 0.75rem 0;
				align-items: center;

				i {
					color: $ultramarine;
					margin-left: 2rem;
				}
			}

			.subnav-more-chapter.expanded {

				.subnav-more-chapter-title {
					border-bottom: 1px solid $rule;
				}

				.subnav-more-chapter-links {
					display: block;
				}

				i {
					transform: rotate(180deg);
				}
			}

			.subnav-more-chapter-links {
				list-style: none;
				margin: 0;
				padding: 0;

				li {
					padding-left: 1rem;
				}
			}
		}
	}

	.subnav-chapter {
		background: $white;
		margin-bottom: px2rem(2);

		&:first-child {
			margin-top: px2rem(2);
		}

		&:last-child {
			margin-bottom: 0;

			@media (max-width: $max-tablet ) {
				.subnav-chapter-title {
					background-color: $nebula;
				}
			}
		}

		.subnav-chapter-title {
			align-items: center;
			color: $carbon;
			display: flex;
			font-weight: 400;
			font-size: 16px;
			line-height: 1.6;
			justify-content: space-between;
			padding: 1rem 1.5rem;
			text-decoration: none;

			@media (min-width: $desktop) {
				border-radius: px2rem(5);
				font-size: 18px;
				line-height: 16.05px;
				height: 0;
				overflow: hidden;
				padding: 0 px2rem(8);

				i {
					color: $ultramarine;
					margin-left: px2rem(9);
					position: relative;
				}
			}
		}

		i {
			color: $ultramarine;
			font-size: 1rem;
			transition: 0.3s all ease;
		}

		&.expanded {

			ul {
				display: block;

				@media (min-width: $desktop) {
					display: none;
				}
			}

			i {
				color: $ultramarine;
				transform: rotate(180deg);

				@media (min-width: $desktop) {
					transform: none;
				}
			}
		}

		.subnav-chapter-links {
			display: none;
			list-style: none;
			margin: 0;
			padding: 0 1.5rem 0 2rem;

			li {
				border-bottom: 1px solid $rule;

				a {
					color: $carbon;
					display: block;
					padding: 0.75rem 0;
					text-decoration: none;

					&:hover {
						color: $ultramarine;
					}
				}

				&:last-child {
					border-bottom: 0;
				}
			}
		}

		&.active {
			@media (min-width: $desktop) {
				background: none;

				.subnav-chapter-title {
					color: $ultramarine;
				}
			}
		}

		@media (min-width: $desktop) {
			background: none;
			cursor: pointer;
			display: flex;
			padding: 0;
			position: relative;
			margin: 0;
			white-space: nowrap;

			&:first-child {
				margin-top: 0;
			}

			&.subnav-more {
				margin: 0;
			}

			&:hover {
				.subnav-chapter-title {
					background: $nebula;

					i {
						transform: rotate(180deg);
					}
				}

				.subnav-chapter-links {
					background: $white;
					border-radius: px2rem(4);
					display: block;
					padding: 0.5rem px2rem(20);
					position: absolute;
					top: px2rem(52);
					min-width: px2rem(184);
					z-index: 1000;
				}
			}

			&.toc-link {
				display: none;
			}
		}
	}

	&.conmkt {

		@media (min-width: $tablet) {
			width: calc(100% + #{px2rem(16)});
		}

		@media screen and (min-width: 47.9375rem) and (max-width: 64rem) {
			left: px2rem(-10);
			margin-left: px2rem(-10);
		}
	}

	@media (max-width: 1024px) {
		.subnav-wrapper.non-guide-sticky {
			top: -52px; // Update the top position appropriately
		}
	}

	.subnav-content.sticky {
		.subnav-chapter:last-child {
			&.subnav-more {
				@media (min-width: $desktop) {
					.subnav-chapter-title {
						background: $ultramarine;
						border-radius: 4px;
						font-size: 18px;
						line-height: 16.05px;
						color: $white;

						i {
							color: $white;
						}

						&:hover {
							background: $imperial;
							border-radius: 0.25rem;
						}
					}

				}
			}
		}
	}
}
</style>
<style lang="scss">
$desktop: px2rem(1025);

.webmd-breadcrumb {
	margin-left: 0;
}

// RR sticky ad needs top offset
.webmd-onc-article .main-container-3 .ad .up-rr-ad {
	top: px2rem(68) !important;
}

.main-container-3 {
	@media (min-width: $desktop) {
		padding-top: 8rem;
	}
}
</style>
